import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const Login = () => {
  const [user, setUser] = useState({});
  const history = useHistory();
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const handleChange = ({ target }) => {
    const name = target && target.name;
    const value = target && target.value;
    setUser({ ...user, [name]: value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await axios.post(
      `${BASE_URL}/api/users/login`,
      user
    );
    
    if (response) {
      localStorage.setItem("user_data", JSON.stringify(response.data.user));
      toast.success("User Login Success");
      setUser({});
      history.push("/");
    }
  };
  return (
    <main className="main-content site-wrapper-reveal">

      {/* <!--== Start Contact Area ==--> */}
      <section className="account-login-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="login-form">
                <form
                  className="login-form-wrapper"
                  id="login-form"
                  action="http://whizthemes.com/mail-php/raju/arden/mail.php"
                  method="post"
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="section-title text-center">
                        <h2 className="title">Login</h2>
                        <p>Please login using account detail bellow.</p>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              className="form-control"
                              type="email"
                              name="email"
                              placeholder="Email"
                              value={user.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-0">
                            <input
                              className="form-control"
                              type="password"
                              name="password"
                              placeholder="Password"
                              value={user.password}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mb-0 form-group-info">
                            <button
                              className="btn btn-theme"
                              type="submit"
                              onClick={(e) => handleSubmit(e)}
                            >
                              SIGN IN
                            </button>                           
                          </div>
                        </div>
                        <div className="col-md-12">
                          {/* <div className="form-group mb-0">
                            <Link className="btn-create" to="#">
                              Create account?
                            </Link>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              {/* <!-- Message Notification --> */}
              <div className="form-message"></div>
            </div>
          </div>
        </div>
      </section>
      {/* <!--== End Contact Area ==--> */}
    </main>
  );
};
export default Login;
